import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import { getKnowledgeBaseRootPath } from '../../../routing/utils/internalPaths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ArticleNotFound extends Component {
  constructor(...args) {
    super(...args);
    this.handleRedirect = () => {
      this.props.onRouteChange(getKnowledgeBaseRootPath());
    };
  }
  render() {
    const {
      className
    } = this.props;
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      className: className,
      type: "notFound",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.insights.articleDetails.articleNotFound"
        })
      }), /*#__PURE__*/_jsx(UILink, {
        onClick: this.handleRedirect,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.knowledgeCenter"
        })
      })]
    });
  }
}
ArticleNotFound.propTypes = {
  className: PropTypes.string,
  onRouteChange: PropTypes.func.isRequired
};
export default ArticleNotFound;